import { useEffect, useState } from "react";
import { useSettings } from "hooks/useStore";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";

const useIsSticky = ({ mobileOnly = false, triggerOnBothWays = false, threshold = 800, isHeader = false, isMenuOpen } = {}) => {
	const [prevScrollY, setPrevScrollY] = useState(0);
	const [isSticky, setIsSticky] = useState();

	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.md });
	const { isCartOpen } = useSettings(["isCartOpen"]);

	const handleScroll = () => {
		const currentScrollY = window.scrollY;

		if (currentScrollY === 0 || currentScrollY < 80) {
			return setIsSticky(undefined);
		}

		if (triggerOnBothWays) {
			setIsSticky(currentScrollY > threshold);

			setPrevScrollY(currentScrollY);
		} else {
			if (Math.abs(prevScrollY - currentScrollY) >= 100 && currentScrollY > threshold) {
				// Stick on scroll up (default behavior)
				if (prevScrollY >= currentScrollY && !isSticky) {
					setIsSticky(true); // Show element
				} else if (prevScrollY < currentScrollY && isSticky) {
					setIsSticky(false); // Hide element
				}

				setPrevScrollY(currentScrollY);
			}
		}
	};

	useEffect(() => {
		if (!isMobile && mobileOnly) return;

		if (window.scrollY === 0 && isHeader) {
			setIsSticky(isMenuOpen ? true : undefined);
		}

		if ((isMenuOpen || isCartOpen) && isHeader) {
			return setIsSticky(true);
		}
		else if ((isMenuOpen || isCartOpen) && !isHeader) {
			return setIsSticky(false);
		}

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [prevScrollY, isMenuOpen, isCartOpen, isMobile]);

	return isSticky;
};

export default useIsSticky;
